import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Indienen from './pages/Indienen';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import OverOns from './pages/OverOns';
import Werkwijze from './pages/Werkwijze';
import Login from './pages/Login';
import Admin from './pages/Admin';
import AlgemeneVoorwaarden from './pages/AlgemeneVoorwaarden';
import Privacybeleid from './pages/Privacybeleid';
import Machtigingsformulier from './pages/Machtigingsformulier';

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/indienen" element={<Indienen />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/over-ons" element={<OverOns />} />
              <Route path="/werkwijze" element={<Werkwijze />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
              <Route path="/privacybeleid" element={<Privacybeleid />} />
              <Route path="/machtigingsformulier" element={<Machtigingsformulier />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
